import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/adeptview.webp';
import screenshot_target from '../../../images/letterfunnel/murugeshramachandran.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Murugesh Ramachandran"
      firstname="Murugesh"
      companyname="AdeptView"
      competition="BPM Company en Valcon"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/murugeshramachandran.js